/* istanbul ignore file */
import { createGetTextResources } from "../../shared/utils/text-resources-algemeen";

export const getMotiveringTextResources = createGetTextResources({
  ToetsjaarTekortTooltip: `Het toetsjaar is het jaar vanaf passeer(ingangs)datum, waarbij het jaar van passeren(ingaan) meetelt als jaar 1. Je kunt het toetsjaar aanpassen via het menu 'Onderhoud', 'Instellingen' onder 'Inregelen', 'Uitgangspunten advies'.`,
  VoorstelKeuzeTooltip: `Het veranderen van de voorstelkeuze heeft als gevolg dat alle motivering pagina’s het gekozen voorstel als uitgangspunt nemen.`
});
